// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
// require("@rails/activestorage").start()
// require("channels")
require("jquery")
//require("bootstrap")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

import LocalTime from 'local-time'
LocalTime.start()

/* Bootstrap modules */
import JQuery from 'jquery';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/flatpickr.min.js';
import 'jquery-validation';
import 'select2/dist/css/select2.min';
import 'select2';
import 'chart.js';
import './clicking_on_tooltip';
import './hovering_on_tooltip';
import './tooltip'
import Plotly from 'plotly.js-dist-min';
import './onboarding';
import './datetime_picker';
import './form_utils';
import './sortable';
import '../theme/js/theme.min';
import '../theme/styles/application';
import './reset_form_selected_inputs';
import 'datatables.net-bs4/css/dataTables.bootstrap4.css'


import { changeValueOptions } from './volumes_search_tags_options'
window.changeValueOptions = changeValueOptions

window.Plotly = Plotly;
window.jQuery = $;
window.$ = $;

require("jquery-datatables-checkboxes");


//import './table';
//import './search';

document.addEventListener("turbolinks:load", function () {

  function openShowModal(url, resource_id, params = {}) {
    let mdl = $("#mdl-show");
    mdl.find(".modal-title").html(resource_id)
    mdl.find(".modal-body-content").hide()
    mdl.find(".modal-body-loading").show()
    mdl.modal('show')
    $.get(url, params).done(function (data) {
      mdl.find(".modal-body-content").html(data)
      mdl.find(".modal-body-loading").hide()
      mdl.find(".modal-body-content").show()

    })

  }

  window.openShowModal = openShowModal;

  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="tab"]').tab();
  $('[data-toggle="select"]').select2()
  $('.alert:not(.nofade)').fadeOut(5000)

  if (document.querySelectorAll('[data-toggle="dashboard"]').length) {
    new Chart('earningsChart', {
      type: 'bar',
      options: {
        animation: { duration: 0 },
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value) {
                return '$' + value + 'k';
              }
            }
          }]
        }
      },
      data: {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [{
          label: 'Sales',
          data: [25, 20, 30, 22, 17, 10, 18, 26, 28, 26, 20, 32]
        }]
      }
    });
  }


  if (document.querySelectorAll('[data-toggle="chart"]').length) {
    document.querySelectorAll('[data-toggle="chart"]').forEach(plotPlotly)
  }

  function plotPlotly(chart) {
    let layout = JSON.parse(chart.dataset.layout)
    //layout.width = $("#" + chart.dataset.target).width()
    delete (layout.width)
    Plotly.newPlot(
      chart.dataset.target,
      JSON.parse(chart.dataset.data),
      layout,
      {
        responsive: true,
        displaylogo: false,
        displayModeBar: false
      }
    );
  }

  window.plotPlotly = plotPlotly;
})
